<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block main-content">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute">
            <TabPane name="adpositioncomplex" label="效果报表"></TabPane>
            <!-- <TabPane name="realtime" label="实时数据"></TabPane> -->
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'comprehensiveadpositionreport',
  data() {
    return {
      currentRoute: 'adpositioncomplex'
    }
  },
  created() {
    if (this.$route.name === 'comprehensiveadpositionreport') this.$router.replace({ name: 'adpositioncomplex' })
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  position: relative;
}
</style>
